import { Component, Input, booleanAttribute, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Button } from '../button/button.component';

@Component({
  selector: 'procure-favorite-button',
  templateUrl: './favorite-button.component.html',
  styleUrl: './favorite-button.component.scss',
  imports: [MatIcon, Button],
})
export class FavoriteButton {
  @Input({ transform: booleanAttribute }) disabled: boolean | null = false;
  @Input({ transform: booleanAttribute }) isSaving: boolean | null = false;

  @Input({ transform: booleanAttribute }) isFavorite:
    | boolean
    | null
    | undefined = false;

  @Input({ transform: booleanAttribute }) small: boolean = false;
  @Input({ transform: booleanAttribute }) light: boolean = false;

  readonly toggleFavorite = output<boolean>();
}
